export default "__VITE_ASSET__CS7x4$sm__"